<template>
  <v-tooltip
    v-if="label"
    location="bottom"
  >
    <template #activator="{ props }">
      <v-btn
        icon
        size="small"
        width="28"
        height="28"
        variant="text"
        rounded="0"
        elevation="0"
        :class="buttonClass"
        v-bind="{ ...btnAttrs, ...props }"
      >
        <v-icon
          size="small"
          :color="resolvedIconColor"
          :class="iconClass"
        >{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
  <v-btn
    v-else
    icon
    size="small"
    width="28"
    height="28"
    variant="text"
    rounded="0"
    elevation="0"
    :class="buttonClass"
    v-bind="btnAttrs"
  >
    <v-icon
      size="small"
      :color="resolvedIconColor"
      :class="iconClass"
    >{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { parseBtnClass, normalizeVuetifyColor } from '@/helpers/vuetifyColor';

export default {
  name: 'BaseDataTableBtn',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    btnClass: {
      type: String,
      default: 'background',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    /**
     * Vuetify 2 passed `color` through $attrs onto the icon v-btn (icon tint).
     * Chip fill always comes from btnClass (`background`), never from this prop.
     */
    color: {
      type: String,
      default: '',
    },
  },

  computed: {
    parsedBtnClass() {
      return parseBtnClass(normalizeVuetifyColor(this.btnClass));
    },

    /** Theme fill for table action chips — same as V2 `:class="'background'"`. */
    fillColorToken() {
      return this.parsedBtnClass.color || 'background';
    },

    buttonClass() {
      const classes = [];
      const token = this.fillColorToken;
      if (token) {
        classes.push(token);
        classes.push(`bg-${token}`);
      }
      if (this.parsedBtnClass.layoutClass) {
        classes.push(this.parsedBtnClass.layoutClass);
      }
      return classes.join(' ');
    },

    resolvedIconColor() {
      if (this.iconColor) {
        return normalizeVuetifyColor(this.iconColor);
      }
      if (this.color) {
        return normalizeVuetifyColor(parseBtnClass(this.color).color || this.color);
      }
      return 'grey-darken-1';
    },

    btnAttrs() {
      const attrs = { ...this.$attrs };
      delete attrs.color;
      return attrs;
    },
  },
};
</script>
